import { apiSlice } from '../../api';
import type {
  GetCompanyTypesResult,
  GetCompanyTypesDTO,
  CreateCompanyTypeResult,
  CreateCompanyTypeDTO,
  UpdateCompanyTypeResult,
  UpdateCompanyTypeDTO,
  DeleteCompanyTypeResult,
  DeleteCompanyTypeDTO,
} from './types';

export const adminCompanyTypesEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getCompanyTypes: build.query<GetCompanyTypesResult, GetCompanyTypesDTO>({
        query: () => ({
          url: '/admin/v1/company-types',
          method: 'GET',
        }),
        providesTags: ['CompanyTypes'],
      }),

      createCompanyType: build.mutation<CreateCompanyTypeResult, CreateCompanyTypeDTO>({
        query: ({ body }) => ({
          url: '/admin/v1/company-types',
          method: 'POST',
          body,
        }),
        invalidatesTags: ['CompanyTypes'],
      }),

      updateCompanyType: build.mutation<UpdateCompanyTypeResult, UpdateCompanyTypeDTO>({
        query: ({ typeId, body }) => ({
          url: `/admin/v1/company-types/${typeId}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['CompanyTypes'],
      }),

      deleteCompanyType: build.mutation<DeleteCompanyTypeResult, DeleteCompanyTypeDTO>({
        query: ({ typeId }) => ({
          url: `/admin/v1/company-types/${typeId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['CompanyTypes'],
      }),
    };
  },
});

export const { useGetCompanyTypesQuery } = adminCompanyTypesEndpoints;
export const { useCreateCompanyTypeMutation } = adminCompanyTypesEndpoints;
export const { useUpdateCompanyTypeMutation } = adminCompanyTypesEndpoints;
export const { useDeleteCompanyTypeMutation } = adminCompanyTypesEndpoints;

export type AdminCompanyTypesEndpointsController = typeof adminCompanyTypesEndpoints;
